import { Reducer } from "redux";

import {
    STROLLER_PRODUCT_GALLERY_FETCH_FAILURE,
    STROLLER_PRODUCT_GALLERY_FETCH_REQUEST,
    STROLLER_PRODUCT_GALLERY_FETCH_SUCCESS,
    StrollerProductGalleryFetchFailureAction,
    StrollerProductGalleryFetchRequestAction,
    StrollerProductGalleryFetchSuccessAction,
} from "@/mk2/apps/strollers/containers/StrollerProductGallery/StrollerProductGallery.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface StrollerProductGalleryState {
    loadingState: LoadingState;
    errorMessage: string;
    strollerId: number | null;
    strollerPhotosIds: number[];
    strollerVariantIds: number[];
}

export const initialStrollerProductGalleryState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    strollerId: null,
    strollerPhotosIds: [],
    strollerVariantIds: [],
};

export interface StrollersProductGalleryState {
    pages: {
        [strollerSlug: string]: StrollerProductGalleryState;
    };
}

export const initialStrollersProductGalleryState: StrollersProductGalleryState = {
    pages: {},
};

declare type StrollersProductGalleryReducerAction =
    | StrollerProductGalleryFetchRequestAction
    | StrollerProductGalleryFetchSuccessAction
    | StrollerProductGalleryFetchFailureAction;

export const strollersProductGalleryReducer: Reducer<
    StrollersProductGalleryState,
    StrollersProductGalleryReducerAction
> = (state = initialStrollersProductGalleryState, action) => {
    switch (action.type) {
        case STROLLER_PRODUCT_GALLERY_FETCH_REQUEST:
        case STROLLER_PRODUCT_GALLERY_FETCH_FAILURE: {
            const key = `${action.strollerSlug}/${action.strollerVariantId}`;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [key]: tupdate(state.pages[key] || initialStrollerProductGalleryState, {
                        loadingState: loadingState(undefined, action),
                        errorMessage: errorMessage(undefined, action),
                    }),
                }),
            });
        }

        case STROLLER_PRODUCT_GALLERY_FETCH_SUCCESS: {
            const key = `${action.strollerSlug}/${action.strollerVariantId}`;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [key]: tupdate(state.pages[key] || initialStrollerProductGalleryState, {
                        loadingState: loadingState(undefined, action),
                        errorMessage: errorMessage(undefined, action),
                        strollerId: action.response.result.stroller,
                        strollerPhotosIds: action.response.result.strollerPhotos,
                        strollerVariantIds: action.response.result.strollerVariants,
                    }),
                }),
            });
        }

        default:
            return state;
    }
};
